export default __webpack_public_path__ + "static/events-light-4dd63ddb2ff4391a416e562040b4f4ca.png";